const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    enableRowGroup: true,
};

const initialState = {
    columns: [],
    goldenDataColumns: [],
    sourceDataColumns: [],
    records: [],
    goldenDataRecords: [],
    sourceDataRecords: [],
    tableName: '',
    apiLoggers: [],
    rowData: [],
    schemaNames: [],
    columnDefinitions: [],
    gridOptions: {
        defaultColDef,
        columnDefs: [],
        enableRangeSelection: true,
        animateRows: true,
        allowContextMenuWithControlKey: true,
        rowGroupPanelShow: 'always',
    },
    contextMenuItems: [],
    dropDown: [],
    clientRecords: [],
    clientColumns: [],
    sourceSummaryData: [],
    groupHistoryData: [],
    groupHistoryRequest: null,
    groupLineageData: [],
    linkedGroupDataRecords: [],
    newGcIdForAdd: [],
    proposedMatchedRecords: [],
    linkedMatchedRecords: [],
    sourceConfigurationChartInfo: [],
    sourceContributionRequest: null,
    proposedMatchedGridOptions: {
        defaultColDef,
        columnDefs: [],
        enableRangeSelection: true,
        animateRows: true,
        allowContextMenuWithControlKey: true,
        rowGroupPanelShow: 'always',
    },
    linkedMatchedGridOptions: {
        defaultColDef,
        columnDefs: [],
        enableRangeSelection: true,
        animateRows: true,
        allowContextMenuWithControlKey: true,
        rowGroupPanelShow: 'always',
    },
    gcHistoricRecords: [],
    linkedGroups: [],
    linkedRowData: [],
    linkedColumns: [],
    linkedDataByGroup: [],
    previousData: [],
    linkedDDs: [],
    tradesChartData: {},
    recordsForAuth: [],
};

export default initialState;
